module.exports = __webpack_public_path__ + "img/ennetix-settings-page.e4cc4fc1.png";